import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  Box, Button, InputBase,
  makeStyles, Typography,
} from '@material-ui/core';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import PropTypes from 'prop-types';

import { AddNote } from '../../services/courses';
import { setAnalytics } from '../../utils';
import TransitionsModal from '../General/TransitionsModal';

const useStyles = makeStyles((theme) => ({
  container: {
    background: theme.palette.background.card,
    padding: theme.spacing(2, 3),
    borderRadius: '10px',
  },
  cardTitle: {
    fontSize: '20px',
    fontFamily: 'Raleway',
    textTransform: 'uppercase',
    color: theme.palette.text.default,
    textAlign: 'center',
  },
  cardContainerInput: {
    background: '#173C67',
    padding: theme.spacing(1, 3),
    margin: theme.spacing(1, 0),
    borderRadius: '10px',
  },
  cardContainerButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'right',
    margin: theme.spacing(1, 0),
  },
  cardContainerUnitButton: {
    margin: theme.spacing(0, 2),
  },
  cardContainerButtonCancel: {
    background: theme.palette.background.grey,
    color: theme.palette.text.default,
    borderRadius: '10px',
    fontFamily: 'Raleway',
    '&:hover': {
      background: theme.palette.background.grey,
    },
  },
  cardContainerButtonSubmit: {
    background: theme.palette.background.secondary,
    color: theme.palette.text.default,
    borderRadius: '10px',
    fontFamily: 'Raleway',
    '&:hover': {
      background: theme.palette.background.secondary,
    },
    '&.$Mui-disabled': {
      backgroundColor: theme.palette.background.buttonDisabled,
      color: theme.palette.text.default,
    },
  },
  textCard: {
    borderRadius: '10px',
    fontFamily: 'Raleway',
    color: theme.palette.text.default,
  },
}));
function NotesCard({ close }) {
  const classes = useStyles();
  const location = useLocation();

  const [inputNote, setInputNote] = useState('');
  const [openConfirm, setOpenConfirm] = useState(false);
  const { sub } = useSelector((store) => store.login);

  const handleChangeTextNote = (event) => {
    setInputNote(event.target.value);
  };
  const handleCloseNotes = () => {
    close();
  };
  const handleCloseModal = () => {
    setOpenConfirm(false);
  };
  const addNoteByUser = async () => {
    await AddNote(
      inputNote,
      sub,
      location.state.course,
      location.state.topic,
      location.state.lessonId,
    );
  };
  const createNote = async () => {
    await addNoteByUser();
    setOpenConfirm(true);
    setAnalytics('Lesson', 'Btn_GuardarNota');
    setInputNote('');
  };
  const styleIconModal = (e) => (<CheckCircleOutlineRoundedIcon className={e} />);
  return (
    <div>
      <Box className={classes.container}>
        <Typography className={classes.cardTitle}>Notas</Typography>
        <Box className={classes.cardContainerInput}>
          <InputBase
            fullWidth
            multiline
            minRows={5}
            onChange={(event) => {
              handleChangeTextNote(event);
            }}
            value={inputNote}
            className={classes.textCard}
          />
        </Box>
        <Box className={classes.cardContainerButtons}>
          <Box className={classes.cardContainerUnitButton}>
            <Button
              variant="contained"
              className={classes.cardContainerButtonCancel}
              onClick={handleCloseNotes}
            >
              Cancelar
            </Button>
          </Box>
          <Box>
            <Button
              variant="contained"
              className={classes.cardContainerButtonSubmit}
              disabled={inputNote === ''}
              onClick={createNote}
            >
              Guardar
            </Button>
          </Box>
        </Box>
      </Box>
      <TransitionsModal
        open={openConfirm}
        handleClose={handleCloseModal}
        textBody="¡Tu nota se ha guardado con éxito!"
        icon={styleIconModal}
      />
    </div>
  );
}

export default NotesCard;

NotesCard.propTypes = {
  close: PropTypes.func.isRequired,
};
